import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    indexs : 0, //选中
    titleName:"首页",
    addressId:'', //详情页锚点
    languageId:3, //语系转换
}
const mutations = {
    changeBack(state,indexs) {
        state.indexs = indexs
        sessionStorage.setItem('dataList',state.indexs)
    },
    changeName(state,titleName) {
        state.titleName = titleName
        sessionStorage.setItem('dataName',state.titleName)
    },
    changeAddressId(state,addressId) {
        state.addressId = addressId
        sessionStorage.setItem('dataAddressId',state.addressId)
    },
    upHeaderLanguage(state,languageId) {
        console.log(state,languageId,'state,languageId');
        state.languageId = languageId
        // sessionStorage.setItem('dataLanguageId',state.languageId)
        localStorage.setItem('dataLanguageId',state.languageId)
    }
}



export default new Vuex.Store({
    state,
    mutations 
})


// WEBPACK FOOTER //
// ./src/store/index.js